import { render } from "./PrivacyPolicyPage.vue?vue&type=template&id=11e19380&scoped=true"
const script = {}

import "./PrivacyPolicyPage.vue?vue&type=style&index=0&id=11e19380&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11e19380"]])

export default __exports__